import React, { Suspense } from 'react';
import { Link, Route, BrowserRouter as Router } from 'react-router-dom';

import NavBreadcrumb from './NavBreadcrumb';
import { NavItem, getRoutes } from './NavItem';
import NavSidebar from './NavSidebar';
import NotFound from './NotFound';

const isExternal = require("is-url-external");

interface RosenauAppTemplateProps {
    homeLink?: string;
    navigation: NavItem;
    currentNavItem?: NavItem;
    hasAnyNavigation: boolean;
    renderNotFoundRoute?: boolean;
    allowPath: (path: string) => boolean;
    renderAccountDropdown?: () => React.ReactNode;
}

export default class RosenauAppTemplate extends React.Component<RosenauAppTemplateProps> {
    constructor(props: Readonly<RosenauAppTemplateProps>) {
        super(props);

        this.state = {};
    }

    render() {
        const { navigation, currentNavItem, renderNotFoundRoute, allowPath, hasAnyNavigation } = this.props;

        const homeLink = this.props.homeLink || "/";

        return <React.Fragment>
            <Router>
                <nav className="navbar flex-md-nowrap p-0 border-bottom">
                    {(element => (!currentNavItem || !currentNavItem.displayFullWidth) && !hasAnyNavigation ? <div className="container-lg pl-0 pr-0">{element}</div> : element)
                        (<React.Fragment>
                            {isExternal(homeLink) ? <a href={homeLink} className={hasAnyNavigation ? "navbar-brand col-md-3 col-lg-2 px-3 py-1 m-0" : "navbar-brand px-3 py-1 m-0"}>
                                <img width="125"
                                    height="41"
                                    src="https://www.rosenau.ca/wp-content/uploads/2018/12/logo-rosenau.png"
                                    className="navbar-brand-img"
                                    alt="Rosenau" />
                            </a> : <Link to="/" className={hasAnyNavigation ? "navbar-brand col-md-3 col-lg-2 px-3 py-1 m-0" : "navbar-brand px-3 py-1 m-0"}>
                                <img width="125"
                                    height="41"
                                    src="https://www.rosenau.ca/wp-content/uploads/2018/12/logo-rosenau.png"
                                    className="navbar-brand-img"
                                    alt="Rosenau" />
                            </Link>}
                            <NavBreadcrumb navigation={this.props.navigation} />
                            {this.props.renderAccountDropdown ? this.props.renderAccountDropdown() : <div className="col-md-2"></div>}
                        </React.Fragment>)}
                </nav>
    
                {hasAnyNavigation && <NavSidebar navigation={this.props.navigation} />}
    
                <main role="main" className={hasAnyNavigation ? "col-md-9 col-lg-10 ml-sm-auto px-4 mb-4" : (currentNavItem && currentNavItem.displayFullWidth ? "ml-sm-auto px-4" : "ml-sm-auto px-4 mb-4")}>
                    <Suspense fallback={<div>Loading...</div>}>
                        <div id="app-template" className={!currentNavItem || !currentNavItem.displayFullWidth ? "component-container container-lg" + (hasAnyNavigation ? " ml-0 mr-0 pl-0 pr-0" : "") : "component-container"}>
                            {getRoutes(navigation, allowPath)}
                            {renderNotFoundRoute !== false ? <Route key="/not-found" path="/not-found" component={NotFound} /> : undefined}
                        </div>
                    </Suspense>
                    <div style={{clear: "both"}}></div>
                </main>
            </Router>
        </React.Fragment>;
    }
}
